import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import * as d3 from 'd3';

@Component({
    selector: 'lib-burnout-chart',
    templateUrl: './burnout-chart.component.html',
    styleUrls: ['./burnout-chart.component.scss']
})
export class BurnoutChartComponent implements OnInit, OnChanges {


    @Input() config: any;

    constructor() {
    }

    ngOnInit(): void {
        this.draw(this.config);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.config && !changes.config.firstChange) {
            this.draw(changes.config.currentValue);
        }
    }

    draw(config: any) {
        const height = 400;
        const width = 800;
        const margin = {top: 30, right: 20, bottom: 40, left: 190};
        d3.select('#line-chart').select('svg').remove();
        const svg = d3.select('#line-chart')
            .append('svg')
            .attr('width', width)
            .attr('height', height)
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .attr('viewBox', [0, 0, width + margin.left + margin.right, height + margin.top + margin.bottom])
            .attr('style', 'max-width: 100%; height: auto;')
            .append('g')
            .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

        const xScale = d3.scaleLinear()
            .domain([config.xAxis.x0, config.xAxis.x1])
            .range([0, width]);
        const yScale = d3.scaleLinear()
            .domain([config.yAxis.y0, config.yAxis.y1])
            .range([height, 0]);
        const line: any = d3.line()
            .x((d: any) => xScale(d.x))
            .y((d: any) => yScale(d.y));
        svg.append('path')
            .datum(config.data.currentPeriod)
            .attr('fill', 'none')
            .attr('stroke', '#000')
            .attr('stroke-width', 2)
            .attr('d', line);


        const line2: any = d3.line()
            .x((d: any) => xScale(d.x))
            .y((d: any) => yScale(d.y));
        // svg.append('path')
        //     .datum(config.data.currentPeriod.map((el: any) => {
        //         el.y = el.y * Math.random() + 12;
        //         return el;
        //     }))
        //     .attr('fill', 'none')
        //     .attr('stroke', '#9F9CAC')
        //     .attr('stroke-width', 2)
        //     .attr('fill', 'none')
        //     .style('stroke-dasharray', ('10, 10'))
        //     .attr('d', line2);
        svg.append('g')
            .attr('transform', `translate(0, ${height})`)
            .call(
                d3.axisBottom(xScale)
                    .tickValues(d3.range(config.xAxis.x0, config.xAxis.x1, 1))
                    .tickSize(0)
                    .tickFormat((d: any) => {
                        return d || '';
                    })
            );
        svg.append('g')
            .attr('class', 'yaxis')
            .call(d3.axisLeft(yScale)
                .ticks(5)
                .tickSize(-width)
            );

        svg.selectAll('.yaxis .tick text')
            .attr('font-family', 'Raleway')
            .attr('font-size', '12px')
            .attr('color', '#10082F')
            .attr('transform', `translate(${width}, -10)`);

        svg.selectAll('.domain')
            .attr('color', `white`);


        svg.append('g')
            .append('rect')
            .attr('width', 60)
            .attr('height', 5)
            .attr('x', -margin.left)
            .attr('y', height - 90)
            .attr('fill', `#10082F`);
        svg
            .append('text')
            .attr('x', -margin.left)
            .attr('y', height - 70)
            .attr('font-family', 'Raleway')
            .attr('font-size', '12px')
            .attr('color', '#10082F')
            .text('Company name');


        svg.append('g')
            .append('rect')
            .attr('width', 10)
            .attr('height', 5)
            .attr('x', -margin.left)
            .attr('y', height - 30)
            .attr('fill', '#9F9CAC');

        svg.append('g')
            .append('rect')
            .attr('width', 10)
            .attr('height', 5)
            .attr('x', -margin.left + 10)
            .attr('y', height - 30)
            .attr('fill', '#fff');
        svg.append('g')
            .append('rect')
            .attr('width', 20)
            .attr('height', 5)
            .attr('x', -margin.left + 20)
            .attr('y', height - 30)
            .attr('fill', '#9F9CAC');
        svg.append('g')
            .append('rect')
            .attr('width', 10)
            .attr('height', 5)
            .attr('x', -margin.left + 40)
            .attr('y', height - 30)
            .attr('fill', '#fff');
        svg.append('g')
            .append('rect')
            .attr('width', 10)
            .attr('height', 5)
            .attr('x', -margin.left + 50)
            .attr('y', height - 30)
            .attr('fill', '#9F9CAC');
        svg
            .append('text')
            .attr('x', -margin.left)
            .attr('y', height - 10)
            .attr('font-family', 'Raleway')
            .attr('font-size', '12px')
            .attr('color', '#10082F')
            .text('Preceding period');
    }
}
